// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowListModal-cls1_mtq","cls2":"BulkFollowListModal-cls2_x1G BulkFollowListModal-cls1_mtq"};